export class Model_CRM_Disposition_Status {

    public DispositionId: number;
    public DispositionDesc: string;

}